import { render, staticRenderFns } from "./MsComboBoxItem.vue?vue&type=template&id=35bb9231&scoped=true"
import script from "./MsComboBoxItem.vue?vue&type=script&lang=js"
export * from "./MsComboBoxItem.vue?vue&type=script&lang=js"
import style0 from "./MsComboBoxItem.vue?vue&type=style&index=0&id=35bb9231&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb9231",
  null
  
)

export default component.exports